import axios from '../../axios'

/*
 * 安全员管理模块
 */

/**
 * 导出Excel
 * @param schoolId 驾校ID
 * @param secunum 安全员编号
 * @param name 安全员姓名
 * @param occupationlevel 职业资格等级1:一级2:二级3:三级4:四级
 * @param teachpermitted 准教车型
 * @param employstatus 供职状态 0:在职； 1:离职
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702556
 */
export const exportExcel = data => {
  return axios({
    url: '/security/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 保存
export const save = (data) => {
    return axios({
        url: '/security/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/security/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/security/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/security/detail',
        method: 'post',
        data
    })
}
// 获取统一编号
export const handleGetNum = (data) => {
  return axios({
    url: '/security/getSecurityNum/' + data,
    method: 'post',
    data
  })
}
// 备案
export const handleRecord = (data) => {
  return axios({
    url: '/security/report/' + data,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/security/security.js